import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';

const AddToHomeCard = ({ 
  title = "Install the App", 
  value = "Click to install", 
  suffix = "", 
  animationData 
}) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    /**
     * Listen for the `beforeinstallprompt` event.
     * This is fired on some browsers when your PWA is eligible for installation.
     */
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so we can trigger it later
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Cleanup
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      // If we don't have the event, either the browser doesn't support it 
      // or the user is not eligible for installation yet
      alert("No install prompt available.");
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user's response
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }

    // We only can use the prompt once.
    setDeferredPrompt(null);
  };



  return (
    <div 
      onClick={handleInstallClick}
      className="
        w-full my-2 bg-[#34495e] border-2 border-[#2ecc71] 
        rounded-[10px] flex items-center justify-between 
        p-4 cursor-pointer
      "
      style={{ minHeight: '50px', maxHeight: '60px' }}
    >
      <div className="flex-shrink-0">
        {animationData && (
          <Lottie 
            animationData={animationData} 
            style={{ width: 40, height: 40 }} 
          />
        )}
      </div>

      <div className="flex items-center flex-col text-white mr-4">
        <span className="text-sm font-extrabold text-[#e67e22]">
          {title}
        </span>
      </div>
    </div>
  );
};

export default AddToHomeCard;
